export type SalonInputData = {
  id: string;
  year: string;
  quarter: string;
  salonDetailPage: string; //salon detail -> nid
  title: string;
  tnSpBeginning: number;
  tnSpEnd: number;
  tnColorTransactions: number;
  tnExistGuestsReturning: number;
  tnExistGuestsServiced: number;
  tnHairTransactions: number;
  tnNewGuestsReturning: number;
  tnNewGuestsServiced: number;
  tnPrebookedAppointments: number;
  tnRetailOnlyTr: number;
  tnServiceTrWithRetail: number;
  tnServiceTransactions: number;
  tnTeamMembersThisYear: number;
  tnTreatmentTransactions: number;
  totalRetailSales: number;
  totalServiceSales: number;
};

export interface ISalonInputFormItem {
  label: string;
  id: string;
  required?: boolean;
}

export const SalonInputFormMap = {
  staff: [
    {
      label: '# of service providers (at the beginning of the quarter)',
      id: 'tnSpBeginning',
      required: true,
    },
    {
      label: '# of same service providers remaining (at the end of the quarter)',
      id: 'tnSpEnd',
      required: true,
    },
    {
      label: '# of team members (this quarter)',
      id: 'tnTeamMembersThisYear',
    },
  ],
  guest: [
    {
      label: 'total # new guests serviced',
      id: 'tnNewGuestsServiced',
    },
    {
      label: 'total # existing guests serviced',
      id: 'tnExistGuestsServiced',
    },
    {
      label: 'total # new service guests returning within 3 months',
      id: 'tnNewGuestsReturning',
    },
    {
      label: 'total # existing service guests returning within 3 months',
      id: 'tnExistGuestsReturning',
    },
    {
      label: '# pre-booked appointments',
      id: 'tnPrebookedAppointments',
    },
  ],
  service: [
    {
      label: 'total service sales',
      id: 'totalServiceSales',
    },
    {
      label: 'total # service transactions',
      id: 'tnServiceTransactions',
    },
    {
      label: 'total # color transactions',
      id: 'tnColorTransactions',
    },
    {
      label: 'total # hair service transactions',
      id: 'tnHairTransactions',
    },
    {
      label: '# service transactions with retail',
      id: 'tnServiceTrWithRetail',
    },
    {
      label: 'total # of treatment transactions',
      id: 'tnTreatmentTransactions',
    },
  ],
  retail: [
    {
      label: 'total retail sales',
      id: 'totalRetailSales',
    },
    {
      label: '# retail only transactions',
      id: 'tnRetailOnlyTr',
    },
  ],
};

export enum SalonInputTitleDescription {
  staff = "These inputs fuel the KPI's about staff",
  guest = "These inputs fuel the KPI's about guests",
  service = "These inputs fuel the KPI's about services",
  retail = "These inputs fuel the KPI's about retail",
  transactions = "These inputs fuel the KPI's about transactions",
}
